/**
 * Canonical carousel export dimensions. Single source of truth shared by the
 * editor export (Workspace) and the server-side /render route, so rendered
 * cards match the editor pixel-for-pixel.
 */
export const EXPORT_WIDTH = 1080;

export function getExportHeight(aspectRatio: string): number {
  switch (aspectRatio) {
    case '1/1': return EXPORT_WIDTH;            // 1080x1080
    case '4/5': return EXPORT_WIDTH * 1.25;     // 1080x1350
    case '16/9': return EXPORT_WIDTH * (9 / 16); // 1080x607.5
    case '9/16': return Math.round(EXPORT_WIDTH * (16 / 9)); // 1080x1920
    default: return EXPORT_WIDTH * 1.25;        // fallback: 4/5
  }
}

export function getExportDimensions(aspectRatio: string): { width: number; height: number } {
  return { width: EXPORT_WIDTH, height: getExportHeight(aspectRatio) };
}
